import QuickSuggestionsOption from 'owa-quick-suggestions-option/lib/QuickSuggestionsOption';
import LinkPreviewOption from 'owa-link-preview-option/lib/LinkPreviewOption';
import MessageFormatOption from 'owa-message-format-option/lib/MessageFormatOption';
import ReplyOption from 'owa-reply-option/lib/ReplyOption';
import SignatureOption from 'owa-signature-option/lib/SignatureOption';
import ConfettiOption from 'owa-confetti-option/lib/ConfettiOption';
var messageContentSubcategory = {
    key: 'messageContent',
    titleStringKey: 'optionSubcategory_messageContent',
    options: [
        SignatureOption,
        MessageFormatOption,
        ReplyOption,
        LinkPreviewOption,
        ConfettiOption,
        QuickSuggestionsOption,
    ],
};
export default messageContentSubcategory;
//# sourceMappingURL=messageContentSubcategory.js.map